import { Component, h, Prop } from '@stencil/core';
import { AmountControlValues } from '../../../../types/types';

@Component({
  tag: 'rentware-amount-control-cart-template',
  styleUrl: 'style-cart.sass',
  shadow: false,
})
export class RentwareAmountControlCartTemplate {
  @Prop() controlValues: AmountControlValues;
  @Prop() onIncreaseValue: (number) => void;
  @Prop() onInputChange: (event) => void;
  @Prop() onValidateKey: (event) => void;

  get minusButtonEnabled() {
    return this.controlValues.itemAmount !== 0 && (this.controlValues.itemAmount > this.controlValues.minAmount || this.minusButtonRemove);
  }

  get minusButtonRemove() {
    return this.controlValues.itemAmount === this.controlValues.minAmount || this.controlValues.itemAmount === 1;
  }

  get minusButtonStyle(): string {
    let minusButtonStyle = 'RCACButton RCACButtonLeft';

    if (this.minusButtonEnabled) {
      minusButtonStyle += ' RCACButtonWaved';

      if (this.minusButtonRemove) {
        minusButtonStyle += ' RCACButtonRemove';
      }
    } else {
      minusButtonStyle += ' RCACButtonDisabled';
    }

    return minusButtonStyle;
  }

  get minusButtonCallback() {
    if (!this.minusButtonEnabled) {
      return () => {};
    }

    if (this.minusButtonRemove) {
      return this.controlValues.deleteArticleCallback;
    }

    return () => this.onIncreaseValue(-1);
  }

  get plusButtonStyleEnabled() {
    return this.controlValues.itemAmount < this.controlValues.maxAmount;
  }

  get plusButtonStyle(): string {
    let plusButtonStyle = 'RCACButton RCACButtonRight';

    if (this.plusButtonStyleEnabled) {
      plusButtonStyle += ' RCACButtonWaved';
    } else {
      plusButtonStyle += ' RCACButtonDisabled';
    }

    return plusButtonStyle;
  }

  get plusButtonCallback() {
    if (this.controlValues.disabled || !this.plusButtonStyleEnabled) {
      return null;
    }

    return () => this.onIncreaseValue(1);
  }

  get deleteButtonEnabled() {
    return this.controlValues.itemAmount >= this.controlValues.minAmount;
  }

  get deleteButtonStyle(): string {
    let deleteButtonStyle = 'RCACButton RCACDeleteButton';

    if (this.showControls || this.showVariationControls) {
      deleteButtonStyle += ' RCACDeleteButtonWithControls';
    }

    if (this.deleteButtonEnabled) {
      deleteButtonStyle += ' RCACButtonWaved';
    } else {
      deleteButtonStyle += ' RCACButtonDisabled';
    }

    return deleteButtonStyle;
  }

  get deleteCallback() {
    if (!this.deleteButtonEnabled) {
      return () => {};
    }

    return this.controlValues.deleteArticleCallback;
  }

  get noAmount() {
    return this.controlValues.maxAmount === 0;
  }

  get singleAmount() {
    return this.controlValues.maxAmount === 1 || this.controlValues.minAmount === this.controlValues.maxAmount;
  }

  get showControls() {
    return !(this.singleAmount || this.showVariationControls);
  }

  get showVariationControls() {
    return this.controlValues.isVariation;
  }

  render() {
    if (this.noAmount) {
      return null;
    }

    return (
      <div class="RCACContainer">
        <div tabindex="0" class={this.deleteButtonStyle} onClick={this.deleteCallback}>
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.46447 1.71052L8.53553 8.78159M8.53553 1.71052L1.46447 8.78159" stroke-width="1.5" stroke-linecap="round" />
          </svg>
        </div>

        {this.showControls && (
          <div class="RCACControls">
            <div tabindex="0" class={this.minusButtonStyle} onClick={this.minusButtonCallback}>
              <svg width="10" height="2" viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1H5H9" stroke-linecap="round" />
              </svg>
            </div>

            <input
              class="RCACAmountInput"
              maxlength="3"
              type="number"
              value={String(this.controlValues.itemAmount)}
              onKeyPress={this.onValidateKey}
              onChange={this.onInputChange}
            />

            <div tabindex="0" class={this.plusButtonStyle} onClick={this.plusButtonCallback}>
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 4.94092H5M9 4.94092H5M5 4.94092V1M5 4.94092V9" stroke-linecap="round" />
              </svg>
            </div>
          </div>
        )}

        {this.showVariationControls && (
          <div class="RCACControls">
            <div tabindex="0" class="RCACButton RCACVariation RCACButtonWaved" onClick={() => this.controlValues.changeAmountCallback(0, 0)}>
              <svg width="10" height="2" viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1H5H9" stroke-linecap="round" />
              </svg>
              /
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 4.94092H5M9 4.94092H5M5 4.94092V1M5 4.94092V9" stroke-linecap="round" />
              </svg>
            </div>
          </div>
        )}

        {this.controlValues.disabled && <div class="RCACAmountWaiting" />}
      </div>
    );
  }
}
